import { render, staticRenderFns } from "./Prompts.vue?vue&type=template&id=10a32b36&scoped=true"
import script from "./Prompts.vue?vue&type=script&lang=js"
export * from "./Prompts.vue?vue&type=script&lang=js"
import style0 from "./Prompts.vue?vue&type=style&index=0&id=10a32b36&prod&scoped=true&lang=css"
import style1 from "./Prompts.vue?vue&type=style&index=1&id=10a32b36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a32b36",
  null
  
)

export default component.exports